module.exports = __webpack_public_path__ + "img/web4.0e8829cf.png";